import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

import { useDataFormStore } from "@/stores/form";

export default (thirdPerson) => ({
  cargoTransportationCustomer: [
    renderRequiredRule("Пожалуйста выберите заказчика"),
    {
      validator: (rule, value, callback) => {
        if (thirdPerson.cargoTransportationCustomer && value === "") {
          callback(new Error("Пожалуйста выберите заказчика"));
        }
        if (value === "Получатель") {
          const dataForm = useDataFormStore();
          if(dataForm.consignee.cityTo.includes('(Москва)')) {
            callback(new Error("Получателем является склад Вайлдбериз, вы не можете быть получателем перевозки"));
          }
          
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeThirdPerson: [],
  innThirdPerson: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: (value) => {
        return checkValidityInn(value);
      },
      message: "Некорректно введён ИНН",
    }),
    {
      validator: (rule, value, callback) => {
        if (!value) return callback();
        if (thirdPerson.typeThirdPerson === 1 && value.length !== 10) {
          callback(new Error("Для юр. лица ИНН должен состоять из 10 символов"));
        } else if (thirdPerson.typeThirdPerson === 2 && value.length !== 12) {
          callback(new Error("Для ИП ИНН должен состоять из 12 символов"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  kppThirdPerson: [
    renderRequiredRule("Пожалуйста введите КПП"),
    renderLengthFieldRule({
      min: 9,
      max: 9,
      message: "КПП должен состоять из 9 символов",
    }),
  ],
  name: [
    renderRequiredRule("Пожалуйста введите название организации"),
  ],
  surnameThirdPerson: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameThirdPerson: [
    renderRequiredRule("Введите имя"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  secondNameThirdPerson: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  phoneThirdPerson: [
    renderRequiredRule("Пожалуйста введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailThirdPerson: [
    {
      validator: (rule, value, callback) => {
        if (
          (thirdPerson.typeThirdPerson && (value === "")) ||
          (!(value === "") && !value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/))
        ) {
          callback(new Error("Пожалуйста введите почту"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
});
